import { useLingui } from "@lingui/react/macro";
import InputField from "@medoma/components/InputField/InputField";
import { useFormContext, type FieldValues } from "react-hook-form";
import { errorMessageAt, withPrefix } from "@/forms/fieldPath";

export const NUMBER_OF_CHARACTERS_ALLOWED_IN_TITLE = 35;

export type ITitleInputFields = {
  title: string;
};

export const TitleInput = ({ namePrefix }: { namePrefix?: string }) => {
  const { t } = useLingui();
  const {
    formState: { errors },
    register,
    trigger,
    clearErrors,
  } = useFormContext<FieldValues>();

  const titlePath = withPrefix(namePrefix, "title");
  const errorMessage = errorMessageAt(errors, titlePath);

  return (
    <InputField
      label={t`Titel`}
      showOptionalLabel={false}
      errorMessage={errorMessage}
      {...register(titlePath, {
        required: {
          value: true,
          message: t`Ange titel`,
        },
        maxLength: {
          value: NUMBER_OF_CHARACTERS_ALLOWED_IN_TITLE,
          message: t`Namnet får max vara ${NUMBER_OF_CHARACTERS_ALLOWED_IN_TITLE} tecken. Lägg ytterligare text i beskrivningen.`,
        },
        onChange: (e) => {
          // User feedback onChange
          if (e?.currentTarget?.value?.length >= 1) {
            void trigger(titlePath);
          } else {
            // ... but don't show annoying errors at this point if the field is empty.
            clearErrors(titlePath);
          }
        },
      })}
    />
  );
};
